import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-026fbbd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white mx-auto pt-6" }
const _hoisted_2 = { class: "flex item-center justify-between mt-6" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "13",
  height: "12",
  viewBox: "0 0 13 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "me-2.5"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 6L5.75 1.25M1 6L5.75 10.75M1 6L12.0833 6",
    stroke: "#344054",
    "stroke-width": "1.58333",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1))
const _hoisted_8 = { class: "fixed inset-0 z-10 w-screen overflow-y-auto" }
const _hoisted_9 = { class: "flex min-h-full items-end justify-center p-8 text-center sm:items-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-auto flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "60",
    height: "60",
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M23.4896 15.8866C21.3327 15.9696 19.3828 16.7394 18.3403 17.7831C18.2252 17.8982 18.0885 17.9895 17.938 18.0517C17.7876 18.114 17.6263 18.146 17.4635 18.146C17.3007 18.1459 17.1395 18.1138 16.9891 18.0514C16.8387 17.989 16.702 17.8977 16.5869 17.7825C16.4719 17.6673 16.3806 17.5306 16.3183 17.3802C16.2561 17.2297 16.2241 17.0685 16.2241 16.9057C16.2242 16.7429 16.2563 16.5816 16.3187 16.4312C16.381 16.2808 16.4724 16.1442 16.5876 16.0291C18.1953 14.4214 20.8133 13.509 23.3929 13.4086C25.9898 13.3082 28.8247 14.0185 30.8105 16.0043C31.043 16.2369 31.1735 16.5523 31.1734 16.8811C31.1733 17.21 31.0425 17.5253 30.8099 17.7577C30.5773 17.9901 30.2619 18.1207 29.9331 18.1205C29.6043 18.1204 29.289 17.9897 29.0565 17.7571C27.7054 16.4047 25.6303 15.8023 23.4896 15.8853V15.8866Z",
      fill: "#4B5563"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M36.1186 33.9448C38.5765 31.0402 39.9225 27.357 39.9167 23.5521C39.9167 14.6519 32.7023 7.4375 23.8021 7.4375C14.9019 7.4375 7.6875 14.6519 7.6875 23.5521C7.6875 32.4523 14.9019 39.6667 23.8021 39.6667C27.7626 39.6667 31.3883 38.2387 34.1948 35.8686L33.7188 38.6056L43.033 47.9198L48.1698 42.783L38.8556 33.4688L36.1186 33.9448ZM23.8021 35.9479C30.6483 35.9479 36.1979 30.3983 36.1979 23.5521C36.1979 16.7059 30.6483 11.1562 23.8021 11.1562C16.9559 11.1562 11.4062 16.7059 11.4062 23.5521C11.4062 30.3983 16.9559 35.9479 23.8021 35.9479Z",
      fill: "#4B5563"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M44.7854 49.6726L49.9222 44.5358L51.6031 46.2166C52.5489 47.1624 52.5489 48.6958 51.6031 49.6404L49.89 51.3535C48.9442 52.2993 47.4108 52.2993 46.4663 51.3535L44.7854 49.6726Z",
      fill: "#4B5563"
    })
  ])
], -1))
const _hoisted_11 = { class: "mt-6 text-center" }
const _hoisted_12 = { class: "mt-4 text-center" }
const _hoisted_13 = { class: "text-sm text-[#475467] mb-2" }
const _hoisted_14 = { class: "text-[#475467]" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = { class: "mt-6 flex justify-around items-center gap-6" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1))
const _hoisted_19 = { class: "fixed inset-0 z-10 w-screen overflow-y-auto" }
const _hoisted_20 = { class: "flex min-h-full items-end justify-center p-8 text-center sm:items-center" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-auto flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "78",
    height: "77",
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      x: "0.9375",
      width: "76.125",
      height: "76.125",
      rx: "38.0625",
      fill: "#155EEF",
      "fill-opacity": "0.24"
    }),
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_16203_15465)" }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M39.5006 29.4282C41.8675 29.4282 43.7863 27.5095 43.7863 25.1425C43.7863 22.7756 41.8675 20.8568 39.5006 20.8568C37.1336 20.8568 35.2148 22.7756 35.2148 25.1425C35.2148 27.5095 37.1336 29.4282 39.5006 29.4282Z",
        stroke: "#155EEF",
        "stroke-width": "2.85714",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M25.2149 55.1425C27.5818 55.1425 29.5006 53.2237 29.5006 50.8568C29.5006 48.4898 27.5818 46.571 25.2149 46.571C22.848 46.571 20.9292 48.4898 20.9292 50.8568C20.9292 53.2237 22.848 55.1425 25.2149 55.1425Z",
        stroke: "#155EEF",
        "stroke-width": "2.85714",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M39.5006 55.1425C41.8675 55.1425 43.7863 53.2237 43.7863 50.8568C43.7863 48.4898 41.8675 46.571 39.5006 46.571C37.1336 46.571 35.2148 48.4898 35.2148 50.8568C35.2148 53.2237 37.1336 55.1425 39.5006 55.1425Z",
        stroke: "#155EEF",
        "stroke-width": "2.85714",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M53.7862 55.1425C56.1531 55.1425 58.0719 53.2237 58.0719 50.8568C58.0719 48.4898 56.1531 46.571 53.7862 46.571C51.4193 46.571 49.5005 48.4898 49.5005 50.8568C49.5005 53.2237 51.4193 55.1425 53.7862 55.1425Z",
        stroke: "#155EEF",
        "stroke-width": "2.85714",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M25.2148 46.5711V40.8568C25.2148 40.099 25.5159 39.3723 26.0517 38.8365C26.5875 38.3007 27.3142 37.9997 28.072 37.9997H50.9291C51.6869 37.9997 52.4136 38.3007 52.9494 38.8365C53.4853 39.3723 53.7863 40.099 53.7863 40.8568V46.5711M39.5006 29.4282V46.5711",
        stroke: "#155EEF",
        "stroke-width": "2.85714",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ]),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_16203_15465" }, [
        /*#__PURE__*/_createElementVNode("rect", {
          width: "40",
          height: "40",
          fill: "white",
          transform: "translate(19.5 18)"
        })
      ])
    ])
  ])
], -1))
const _hoisted_22 = { class: "mt-6 text-center" }
const _hoisted_23 = { class: "mt-4 text-center" }
const _hoisted_24 = { class: "text-sm text-[#475467]" }
const _hoisted_25 = { class: "mt-6 flex justify-around items-center gap-6" }

import { union } from "lodash";
import { ref, onBeforeMount, computed } from "vue";
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";

import PageHeaderComponent from "@/components/global/PageHeaderComponent.vue";
import { useSchoolStore } from "@/stores/schoolStore";
import { useLearnerStore } from "@/stores/learnerStore";
import { useRolloverStore } from "@/stores/rolloverStore";
import { Rollover } from "@/interfaces/rollover.interface";
import LearnersRolloverTableComponent from "@/modules/main/components/LearnersRolloverTableComponent.vue";
import { useRouter } from "vue-router";
import TutorialModalComponent from "../components/TutorialModalComponent.vue";

type LearnersRolloverTableInstance = InstanceType<
  typeof LearnersRolloverTableComponent
>;

// Data stores

export default /*#__PURE__*/_defineComponent({
  __name: 'IncompleteRolloverView',
  setup(__props) {

const router = useRouter();

// Types or Interfaces
const schoolStore = useSchoolStore();
const learnerStore = useLearnerStore(); 
const rolloverStore = useRolloverStore();

// Local State: Read & Update
const showModal = ref(false);
const isGoingBack = ref(false);
const currentGradeIndex = ref(0);
const allGradeLevels = ref<any>([]);
const confirmationModal = ref(false);
const goToClassReviewModal = ref(false);
const learnersRolloverTable = ref<LearnersRolloverTableInstance | null>(null);

// Local Reactive Variables: Usually for Read Only
const currentGrade = computed(
  () => allGradeLevels.value[currentGradeIndex.value]
);

const allLearners = computed(() => learnerStore.getSchoolLearners.length);
const learnersLeaving = computed(() => rolloverStore.rollover?.learnerActions.leaving.length || 0);
const learnersRepeating = computed(() => rolloverStore.rollover?.learnerActions.repeating.length || 0);

const advancingLearners = computed(
  () => allLearners.value - (learnersLeaving.value + learnersRepeating.value)
);

// Things to do before the component is mounted
onBeforeMount(async () => {
  allGradeLevels.value = schoolStore.currentSchoolStructure?.gradeLevels.sort((a, b) => a - b);

  const currentRollOver = rolloverStore.rollover as Rollover;

  if (currentRollOver && currentRollOver.status.learnerRollover === "to_do") {
    currentRollOver.status.learnerRollover = "in_review";
    await rolloverStore.updateRolloverObject(currentRollOver);
  }
});

// save progress button logic
const saveProgress = async () => {
  console.log("Saving Progress: ")
  if (learnersRolloverTable.value) {
    const learnersToRemove = learnersRolloverTable.value.learnersToRemove;
    const learnersToRepeat = learnersRolloverTable.value.learnersToRepeat;
    const currentRollObject = rolloverStore.rollover as Rollover;

    const currentGradeLearnerIds = learnerStore.schoolLearners
      .filter(l => l.grade == currentGrade.value)
      .map(l => l._id);

    // For learners leaving:
    // Remove any current grade learner IDs from the overall 'leaving' list
    currentRollObject.learnerActions.leaving = currentRollObject.learnerActions.leaving.filter(
      (id) => !currentGradeLearnerIds.includes(id)
    )

    // Now add the current grade's selections
    currentRollObject.learnerActions.leaving = union(
      currentRollObject.learnerActions.leaving,
      learnersToRemove
    );

    // For learners repeating:
    // Remove any current grade learner IDs from the overall 'repeating' list
    currentRollObject.learnerActions.repeating = currentRollObject.learnerActions.repeating.filter(
      (id) => !currentGradeLearnerIds.includes(id)
    );
    // Now add the current grade's selections
    currentRollObject.learnerActions.repeating = union(
      currentRollObject.learnerActions.repeating,
      learnersToRepeat
    );

    await rolloverStore.updateRolloverObject(currentRollObject);
  }
};

const confirmLearnerRolloverDetails = async () => {
  const currentRollObject = rolloverStore.rollover as Rollover;

  currentRollObject.status.learnerRollover = "pending_job_run";
  await rolloverStore.updateRolloverObject(currentRollObject);

  confirmationModal.value = false;
  goToClassReviewModal.value = true;
};

// Function to navigate to the next grade level
const nextGrade = async () => {
  await saveProgress();
  isGoingBack.value = false;

  if (
    currentGrade.value < allGradeLevels.value[allGradeLevels.value.length - 1]
  ) {
    currentGradeIndex.value++;
  } else if (
    currentGrade.value === allGradeLevels.value[allGradeLevels.value.length - 1]
  ) {
    confirmationModal.value = true;
  }
};

const previousGrade = async () => {
  await saveProgress();

  if (currentGradeIndex.value > 0) {
    isGoingBack.value = true;
    currentGradeIndex.value--;
  }
};

const goBack = () => {
  goToClassReviewModal.value = false;
};

const goToClassReview = async () => {
  const currentRollObject = rolloverStore.rollover as Rollover;

  if (currentRollObject && currentRollObject.status.classReview === "to_do") {
    currentRollObject.status.classReview = "in_review";
    await rolloverStore.updateRolloverObject(currentRollObject);
  }

  goToClassReviewModal.value = false;
  router.push("/main/review-class-structure");
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PageHeaderComponent, { pageHeading: 'Rollover' }),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(LearnersRolloverTableComponent), {
          key: currentGrade.value,
          gradeLevel: currentGrade.value,
          ref_key: "learnersRolloverTable",
          ref: learnersRolloverTable,
          isGoingBack: isGoingBack.value
        }, null, 8, ["gradeLevel", "isGoingBack"])),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, { to: "/main/internal-edit-school" }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (saveProgress())),
                class: "px-4 p-2 justify-center font-semibold text-[#344054] text-base border-[#D0D5DD] border rounded-lg font-medium flex items-center bg-transparent shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] text-center bg-whitemax-w-[95px]"
              }, [
                _hoisted_3,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("rollover.incomplete_view_screen.back")), 1)
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            (currentGradeIndex.value > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "px-4 p-2 justify-center font-semibold text-[#344054] text-base border-[#D0D5DD] border rounded-lg font-medium flex items-center bg-transparent shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] text-center bg-whitemax-w-[95px] mr-2",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (previousGrade()))
                }, _toDisplayString(_ctx.$t("rollover.incomplete_view_screen.previous")), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "px-4 py-2 bg-[#0060EE] text-white rounded-lg flex items-center justify-center cursor-pointer",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (nextGrade()))
            }, [
              (currentGrade.value < allGradeLevels.value[allGradeLevels.value.length - 1])
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t("rollover.incomplete_view_screen.confirm_review_next_grade")), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t("rollover.incomplete_view_screen.confirm_rollover")) + " " + _toDisplayString(advancingLearners.value) + " " + _toDisplayString(_ctx.$t("rollover.incomplete_view_screen.students")), 1))
            ])
          ])
        ])
      ]),
      _createVNode(_unref(TransitionRoot), {
        as: "template",
        show: confirmationModal.value
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Dialog), {
            as: "div",
            class: "relative z-40",
            onClose: _cache[5] || (_cache[5] = ($event: any) => (confirmationModal.value = false))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_unref(TransitionChild), {
                    as: "template",
                    enter: "ease-out duration-300",
                    "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                    "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                    leave: "ease-in duration-200",
                    "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                    "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DialogPanel), { class: "p-8 relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _hoisted_10,
                            _createElementVNode("div", _hoisted_11, [
                              _createVNode(_unref(DialogTitle), {
                                as: "h3",
                                class: "text-lg font-semibold leading-6 text-[#101828]"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("rollover.modal.incomplete_view.confirm_selection")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("rollover.modal.incomplete_view.you_selected")) + ": ", 1),
                              _createElementVNode("p", _hoisted_14, [
                                _createTextVNode(_toDisplayString(advancingLearners.value) + " " + _toDisplayString(_ctx.$t("rollover.modal.incomplete_view.students_to_move")) + " " + _toDisplayString(_ctx.$t("global.grade_naming_convention")), 1),
                                _hoisted_15,
                                _createTextVNode(" " + _toDisplayString(learnersRepeating.value) + " " + _toDisplayString(_ctx.$t("rollover.modal.incomplete_view.students_to_remain")) + " " + _toDisplayString(_ctx.$t("global.grade_naming_convention")), 1),
                                _hoisted_16,
                                _createTextVNode(" " + _toDisplayString(learnersLeaving.value) + " " + _toDisplayString(_ctx.$t("rollover.modal.incomplete_view.students_to_remove")), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "text-[#344054] border border-[#D0D5DD] rounded-lg p-2.5 text-base flex flex-row justify-center items-center flex-wrap w-1/2",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (confirmationModal.value = false))
                            }, _toDisplayString(_ctx.$t("rollover.modal.incomplete_view.edit")), 1),
                            _createElementVNode("button", {
                              type: "button",
                              class: "bg-[#155EEF] rounded-lg p-2.5 text-base shadow-lg text-white flex flex-row justify-center items-center flex-wrap w-1/2",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (confirmLearnerRolloverDetails()))
                            }, _toDisplayString(_ctx.$t("rollover.modal.incomplete_view.correct")), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(_unref(TransitionRoot), {
        as: "template",
        show: goToClassReviewModal.value
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Dialog), {
            as: "div",
            class: "relative z-40",
            onClose: _cache[8] || (_cache[8] = ($event: any) => (goToClassReviewModal.value = false))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_unref(TransitionChild), {
                    as: "template",
                    enter: "ease-out duration-300",
                    "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                    "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                    leave: "ease-in duration-200",
                    "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                    "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DialogPanel), { class: "p-8 relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _hoisted_21,
                            _createElementVNode("div", _hoisted_22, [
                              _createVNode(_unref(DialogTitle), {
                                as: "h3",
                                class: "text-lg font-semibold leading-6 text-[#101828]"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("rollover.modal.incomplete_view.review_structure")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t("rollover.modal.incomplete_view.review_text")) + " " + _toDisplayString(_ctx.$t("global.grade_naming_convention")) + ". ", 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_router_link, {
                              to: "/main/overview",
                              class: "w-1/2"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "text-[#344054] border border-[#D0D5DD] rounded-lg p-2.5 rounded-full px-8 py-2 text-base mx-2 flex flex-row justify-center items-center flex-wrap w-full",
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (goBack()))
                                }, _toDisplayString(_ctx.$t("rollover.modal.incomplete_view.do_later")), 1)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("button", {
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (goToClassReview())),
                              type: "button",
                              class: "bg-[#155EEF] rounded-lg p-2.5 text-base shadow-lg text-white flex flex-row justify-center items-center flex-wrap w-1/2"
                            }, _toDisplayString(_ctx.$t("rollover.modal.incomplete_view.review_now")), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _createVNode(TutorialModalComponent, {
      show: showModal.value,
      "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => ((showModal).value = $event))
    }, {
      headerSlot: _withCtx(() => [
        _createTextVNode(" Tutorial ")
      ]),
      descriptionSlot: _withCtx(() => [
        _createTextVNode(" Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusamus commodi, suscipit, unde deleniti distinctio qui culpa vero repudiandae eum provident laudantium officia laboriosam harum iste fugit nobis minus, consectetur dolorem. ")
      ]),
      strapiContent: _withCtx(() => [
        _createTextVNode(" Strapi content to go here... ")
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})